import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "site-footer" }
const _hoisted_2 = { class: "copyright" }


export default /*@__PURE__*/_defineComponent({
  __name: 'AppFooter',
  setup(__props) {

const year = new Date().getFullYear();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("footer", _hoisted_1, [
    _createElementVNode("p", _hoisted_2, [
      _createElementVNode("small", null, "© " + _toDisplayString(_unref(year)) + " Danilo Targas", 1)
    ])
  ]))
}
}

})